import * as React from 'react';

import gql from 'graphql-tag';

import { isGradedItemOutcome } from 'bundles/degree-home/types/Course';
import type { ComputedOutcome, ComputedProgress } from 'bundles/degree-home/types/Course';

import _t from 'i18n!nls/degree-home';

import 'css!./__styl__/Grade';

type Props = {
  isOverdue: boolean;
  computedProgress: ComputedProgress;
  computedOutcome?: ComputedOutcome;
};

class Grade extends React.Component<Props> {
  static fragment = gql`
    fragment DegreeGradeFragment on DegreeLearnerProgressesV1_org_coursera_degree_learner_ItemState {
      computedProgress {
        progressState
      }
      computedOutcome {
        ... on DegreeLearnerProgressesV1_org_coursera_degree_learner_OutcomeMember {
          org_coursera_degree_learner_Outcome {
            grade
            isPassed
          }
        }
        ... on DegreeLearnerProgressesV1_org_coursera_degree_learner_NotGradedItemOutcomeMember {
          org_coursera_degree_learner_NotGradedItemOutcome {
            computedAt
          }
        }
      }
    }
  `;

  render() {
    const { isOverdue, computedOutcome, computedProgress } = this.props;

    if (computedProgress.progressState === 'InReview' || computedProgress.progressState === 'Optional') {
      return null;
    } else if (
      computedOutcome &&
      computedOutcome.org_coursera_degree_learner_Outcome &&
      isGradedItemOutcome(computedOutcome.org_coursera_degree_learner_Outcome) &&
      computedOutcome.org_coursera_degree_learner_Outcome.grade
    ) {
      const roundedGrade = Math.round(computedOutcome.org_coursera_degree_learner_Outcome.grade * 100);
      return <span className="bt3-hidden-xs text">{roundedGrade}%</span>;
    } else if (isOverdue) {
      return <span className="bt3-hidden-xs text">{_t('Overdue')}</span>;
    }
    return null;
  }
}

export default Grade;
